import { type ReactNode, useMemo } from 'react';
import { CssBaseline, ThemeProvider as MuiThemeProvider } from '@mui/material';
import { createTheme, useTheme } from '@mui/material/styles';
import * as locales from '@mui/material/locale';
import { useTranslation } from 'react-i18next';

type MuiLocale = keyof typeof locales;

export default function LocalizedThemeProvider({ children }: { children: ReactNode }) {
  const theme = useTheme();
  const { i18n } = useTranslation();

  const localizedTheme = useMemo(() => {
    const fullLocale = Object.keys(locales).find((key) => key.slice(0, 2) === i18n.resolvedLanguage) as MuiLocale;
    return createTheme(theme, locales[fullLocale]);
  }, [i18n.resolvedLanguage, theme]);

  return (
    <MuiThemeProvider theme={localizedTheme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
}
